import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer" id="footer">
      <div className="footer-content">
        <div className="footer-section">
          <div className="footer-logo">
            <img src="/images/Store Logo - Kid's Vibes with Earrings.png" alt="Kid's Vibes" />
            <h3>Kid's Vibes</h3>
          </div>
          <p className="footer-description">
            Your trusted destination for premium collectibles, and accessories. 
            Bringing joy and creativity to everyone.
          </p>
        </div>

        <div className="footer-section">
          <h4>Contact Info</h4>
          <div className="contact-info">
            <div className="contact-item">
              <img src="/images/icons8-phone-50.png" alt="Phone" className="contact-icon-img" />
              <span>09966369870 / 09794257796</span>
            </div>
            <div className="contact-item">
              <img src="/images/icons8-viber-48.png" alt="Viber" className="contact-icon-img" />
              <span>09794257796</span>
            </div>
            <div className="contact-item">
              <img src="/images/icons8-telegram-48.png" alt="Telegram" className="contact-icon-img" />
              <span>@http_kid</span>
            </div>
          </div>
        </div>

        <div className="footer-section">
          <h4>Follow Us</h4>
          <div className="social-links">
            <a href="https://www.facebook.com/share/1ArMwj2YWH/?mibextid=wwXIfr" className="social-link">
              <img src="/images/icons8-facebook-logo-48.png" alt="Facebook" className="social-icon-img" />
              Facebook
            </a>
            <a href="https://www.instagram.com/kidsvibesishere?igsh=MTQxeDYxODFtcThjag==" className="social-link">
              <img src="/images/icons8-instagram-48.png" alt="Instagram" className="social-icon-img" />
              Instagram
            </a>
            <a href="https://www.tiktok.com/@kidsvibesmdy?_t=ZS-8zOQki6p5PT&_r=1" className="social-link">
              <img src="/images/icons8-tik-tok-48.png" alt="TikTok" className="social-icon-img" />
              TikTok
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>&copy; 2024 Kid's Vibes. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="#">Privacy Policy</a>
            <span>•</span>
            <a href="#">Terms of Service</a>
            <span>•</span>
            <a href="#">Return Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
